<template>
  <a
    tabindex="0"
    :class="$style.contentButton"
  >
    <span
      v-if="type === 'add'"
      v-once
      :class="$style.icon"
    >
      <IconAdd />
    </span>
    <span
      v-else-if="type === 'remove'"
      v-once
      :class="$style.icon"
    >
      <IconRemove />
    </span>
    <span
      v-else-if="type === 'import'"
      v-once
      :class="$style.icon"
    >
      <IconImport />
    </span>
    <div
      v-if="label"
      :class="$style.text"
    >
      {{ label }}
    </div>
  </a>
</template>

<style lang="scss" module>
.contentButton {
  display: inline-block;
  cursor: pointer;
  outline: none;
}

.icon,
.text {
  display: inline-block;
  vertical-align: middle;
}

.icon {
  width: 20px;
  height: 20px;
  transition: 0.3s transform;

  svg {
    width: 100%;
    height: 100%;
  }

  .contentButton:hover & {
    transform: scale(1.2);
  }
}

.text {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.6px;
  color: #e73273;
  margin-left: 14px;
}
</style>

<script>
import IconAdd from '@/images/icons/add.svg';
import IconRemove from '@/images/icons/remove.svg';
import IconImport from '@/images/icons/import.svg';

export default {
  components: {
    IconAdd,
    IconRemove,
    IconImport,
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      required: true,
      validator(value) {
        return ['add', 'remove', 'import'].indexOf(value) !== -1;
      },
    },
  },
};
</script>
